/**
 * User: scarlson
 * Date: 05/13/2013
 * Time: 07:54 PM
 */

define(function(require) {
    var Backbone = require('backbone');
    
    return Backbone.Model.extend({
    	cacheKey: null,
    	checkCache: true,
    	
        fetch: function(options) {
        	var cacheKey = this._getCacheKey();
        	
            if (this._useCache(options) && oeApp.hasData(cacheKey)) {
                this.set(oeApp.getData(cacheKey), options)
                if (options.success) options.success(this, null, options);
            } else {
            	return Backbone.Model.prototype.fetch.apply(this, arguments);
            }
        },
        
        _getCacheKey: function() {
        	return this.cacheKey; // TODO: SAC: auto-key? || this.url;
        },
        
        _useCache: function(options) {
        	return (this.checkCache && this._getCacheKey() && !options.force);
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./js/common/models/OEBaseModel.js
// module id = 9
// module chunks = 25 26